class CartDrawer extends HTMLElement{constructor(){super();this.addEventListener('keyup',(evt)=>evt.code==='Escape'&&this.close());this.querySelector('#CartDrawer-Overlay').addEventListener('click',this.close.bind(this));this.setHeaderCartIconAccessibility();}
setHeaderCartIconAccessibility(){const cartLink=document.querySelector('#cart-icon-bubble');if(!cartLink)return;cartLink.setAttribute('role','button');cartLink.setAttribute('aria-haspopup','dialog');cartLink.addEventListener('click',(event)=>{event.preventDefault();this.open(cartLink);});cartLink.addEventListener('keydown',(event)=>{if(event.code.toUpperCase()==='SPACE'){event.preventDefault();this.open(cartLink);}});}
open(triggeredBy){if(triggeredBy)this.setActiveElement(triggeredBy);const cartDrawerNote=this.querySelector('[id^="Details-"] summary');if(cartDrawerNote&&!cartDrawerNote.hasAttribute('role'))this.setSummaryAccessibility(cartDrawerNote);setTimeout(()=>{this.classList.add('animate','active');});this.addEventListener('transitionend',()=>{const containerToTrapFocusOn=this.classList.contains('is-empty')?this.querySelector('.drawer__inner-empty'):document.getElementById('CartDrawer');const focusElement=this.querySelector('.drawer__inner')||this.querySelector('.drawer__close');trapFocus(containerToTrapFocusOn,focusElement);},{once:true});document.body.classList.add('overflow-hidden');}
close(){this.classList.remove('active');removeTrapFocus(this.activeElement);document.body.classList.remove('overflow-hidden');}
setSummaryAccessibility(cartDrawerNote){cartDrawerNote.setAttribute('role','button');cartDrawerNote.setAttribute('aria-expanded','false');if(cartDrawerNote.nextElementSibling.getAttribute('id')){cartDrawerNote.setAttribute('aria-controls',cartDrawerNote.nextElementSibling.id);}
cartDrawerNote.addEventListener('click',(event)=>{event.currentTarget.setAttribute('aria-expanded',!event.currentTarget.closest('details').hasAttribute('open'));});cartDrawerNote.parentElement.addEventListener('keyup',onKeyUpEscape);}
renderContents(parsedState){this.querySelector('.drawer__inner').classList.contains('is-empty')&&this.querySelector('.drawer__inner').classList.remove('is-empty');this.productId=parsedState.id;this.getSectionsToRender().forEach((section)=>{const sectionElement=section.selector?document.querySelector(section.selector):document.getElementById(section.id);if(!sectionElement)return;sectionElement.innerHTML=this.getSectionInnerHTML(parsedState.sections[section.id],section.selector);});setTimeout(()=>{this.querySelector('#CartDrawer-Overlay').addEventListener('click',this.close.bind(this));this.open();});}
getSectionInnerHTML(html,selector='.shopify-section'){return new DOMParser().parseFromString(html,'text/html').querySelector(selector).innerHTML;}
getSectionsToRender(){return[{id:'cart-drawer',selector:'#CartDrawer',},{id:'cart-icon-bubble',},];}
getSectionDOM(html,selector='.shopify-section'){return new DOMParser().parseFromString(html,'text/html').querySelector(selector);}
setActiveElement(element){this.activeElement=element;}}
customElements.define('cart-drawer',CartDrawer);class CartDrawerItems extends CartItems{getSectionsToRender(){return[{id:'CartDrawer',section:'cart-drawer',selector:'.drawer__inner',},{id:'cart-icon-bubble',section:'cart-icon-bubble',selector:'.shopify-section',},];}}
customElements.define('cart-drawer-items',CartDrawerItems);

if (!customElements.get('cart-discount')) {
  customElements.define(
    'cart-discount',
    class CartDiscount extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[name="discount"]');
        this.applyButton = this.querySelector('.cart-discount__button');
        this.messageElement = this.querySelector('.cart-discount__message');

        if (this.applyButton && !this.applyButton.hasAttribute('data-bound')) {
          this.applyButton.setAttribute('data-bound', 'true');
          this.applyButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.applyDiscount();
          });
        }

        if (this.input && !this.input.hasAttribute('data-bound')) {
          this.input.setAttribute('data-bound', 'true');
          this.input.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              this.applyDiscount();
            }
          });
        }

        if (!this.hasAttribute('data-remove-bound')) {
          this.setAttribute('data-remove-bound', 'true');
          this.addEventListener('click', (event) => {
            const removeBtn = event.target.closest('.cart-discount__remove-btn');
            if (removeBtn) {
              event.preventDefault();
              this.removeDiscount();
            }
          });
        }
      }

      applyDiscount() {
        const code = this.input ? this.input.value.trim() : '';
        if (!code) return;

        this.setLoading(true);
        this.setMessage('');

        const body = JSON.stringify({
          discount: code,
          sections: ['cart-drawer', 'cart-icon-bubble'],
        });

        fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          body,
        })
          .then((response) => response.json())
          .then((parsedState) => {
            const appliedDiscounts =
              parsedState.discount_applications ||
              parsedState.cart_level_discount_applications ||
              [];
            const isApplied =
              appliedDiscounts.some((d) => d.title && d.title.toLowerCase() === code.toLowerCase()) ||
              appliedDiscounts.length > 0 ||
              (parsedState.total_discount && parsedState.total_discount > 0);

            this.updateDrawerDOM(parsedState, true);

            if (isApplied) {
              this.setMessage('Coupon applied successfully!', false);
            } else {
              this.setMessage('Invalid or non-applicable coupon code', true);
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount', cartData: parsedState });
            }
          })
          .catch((error) => {
            console.error(error);
            this.setMessage('Failed to apply coupon. Please try again.', true);
          })
          .finally(() => {
            this.setLoading(false);
          });
      }

      removeDiscount() {
        this.setLoading(true);
        const body = JSON.stringify({
          discount: '',
          sections: ['cart-drawer', 'cart-icon-bubble'],
        });

        fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          body,
        })
          .then((response) => response.json())
          .then((parsedState) => {
            this.updateDrawerDOM(parsedState, false);

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount', cartData: parsedState });
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.setLoading(false);
          });
      }

      updateDrawerDOM(parsedState, keepDetailsOpen = false) {
        if (!parsedState.sections || !parsedState.sections['cart-drawer']) return;
        const html = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html');

        const selectors = ['.drawer__inner', '#cart-icon-bubble'];
        selectors.forEach((selector) => {
          const target = document.querySelector(selector);
          const source = html.querySelector(selector);
          if (target && source) {
            target.innerHTML = source.innerHTML;
          }
        });

        if (keepDetailsOpen) {
          const details = document.querySelector('#Details-CartDrawer-Coupon');
          if (details) {
            details.setAttribute('open', '');
          }
        }
      }

      setLoading(isLoading) {
        const btn = document.querySelector('.cart-discount__button') || this.applyButton;
        if (btn) {
          btn.disabled = isLoading;
          const spinner = btn.querySelector('.loading__spinner');
          const btnText = btn.querySelector('.cart-discount__button-text');
          if (spinner) spinner.classList.toggle('hidden', !isLoading);
          if (btnText) btnText.style.opacity = isLoading ? '0' : '1';
        }
      }

      setMessage(msg, isError = false) {
        const msgEl = document.querySelector('.cart-discount__message') || this.messageElement;
        if (!msgEl) return;
        msgEl.textContent = msg;
        msgEl.classList.toggle('hidden', !msg);
        msgEl.classList.toggle('cart-discount__message--error', isError);
        msgEl.classList.toggle('cart-discount__message--success', !isError && !!msg);
      }
    }
  );
}